const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 35,
    viewBox: "0 0 15.875 9.2604",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-299.77 -148.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34.387 -19.882)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.66187 0 0 .66187 122.93 51.926)",
    d: "m327.14 178.04 2.0015 3.4668-2.0015 3.4668h-4.0031l-2.0015-3.4668 2.0015-3.4668z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7995,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.66187 0 0 .66187 126.9 54.221)",
    d: "m327.14 178.04 2.0015 3.4668-2.0015 3.4668h-4.0031l-2.0015-3.4668 2.0015-3.4668z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7995,
      stroke: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.66187 0 0 .66187 130.88 51.926)",
    d: "m327.14 178.04 2.0015 3.4668-2.0015 3.4668h-4.0031l-2.0015-3.4668 2.0015-3.4668z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.7995,
      stroke: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHex);
export default __webpack_public_path__ + "static/media/icon_hex.d3836c30a038aa5bceed0fd683238ada.svg";
export { ForwardRef as ReactComponent };